import { Edit, SimpleForm } from "react-admin";
import EditSaveForm from "./Partials/EditSaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";

const EditPostgraduateCourses = props => (
  <Edit
    mutationMode="pessimistic"
    actions={<BackButtonToolbar />}
    title="Редактиране на следдипломен курс"
    transform={data => {
      if (data.courses && Array.isArray(data.courses)) {
        data.courses.forEach(course => {
          if (course.maxParticipants === null) course.maxParticipants = "";
          if (course.note === null) course.note = "";
          if (course.durationInCalendarDays === null) course.durationInCalendarDays = "";
        });
      }
      return data;
    }}
  >
    <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
      <EditSaveForm />
    </SimpleForm>
  </Edit>
);

export default EditPostgraduateCourses;
